import { render, staticRenderFns } from "./ReportFacturae.vue?vue&type=template&id=53a33401&"
import script from "./ReportFacturae.vue?vue&type=script&lang=ts&"
export * from "./ReportFacturae.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports